<template>
  <div>
    <v-container class="my-0 py-0">
      <v-row>
        <v-col class="my-0 py-0">
          <SearchesList
            :selected="selected"
            @select="handleSelect"
          ></SearchesList>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "NotificationsSearches",
  components: {
    SearchesList: () => import("@/components/search/SearchesList"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
  },
  data: () => ({
    modal: false,
  }),
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
  },
  mounted() {},
  methods: {
    closeModal() {
      this.modal = false;
    },
    handleClickCancel() {
      this.closeModal();
    },
    handleSelect(notification) {
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
};
</script>

<style scoped></style>
